function TransactionsPainel({ companyData }) {
  return (
    <div className="panel panel-default">
      <div className="panel-heading" id="panel-heading-transactions">
        <h4>BRL Transactions</h4>
        <span className="panel-info">(* Last 30 Days)</span>
      </div>
      <div className="panel-body">
        {/* Deposits */}
        <h4>Deposits</h4>
        <div className="row">
          <div className="col-sm-4">
            <span>
              Successful Deposits
              <br />
              <strong className="company-data-value">
                {companyData.successful_deposits_count}
              </strong>
            </span>
          </div>
          <div className="col-sm-4">
            <span>
              Successful Deposits Volume
              <br />
              <strong className="company-data-value">
                +{" "}
                {companyData.successful_deposits_amount_sum?.toLocaleString(
                  "pt-br",
                  {
                    style: "currency",
                    currency: "BRL",
                  }
                )}
              </strong>
            </span>
          </div>
          <div className="col-sm-4">
            <span>
              Successful Deposits Users
              <br />
              <strong className="company-data-value">
                {companyData.successful_deposit_users_count}
              </strong>
            </span>
          </div>
        </div>

        {/* Withdrawals */}
        <div className="transactions-row-container">
          <h4>Withdrawals</h4>
          <div className="row">
            <div className="col-sm-4">
              <span>
                Successful Withdrawals
                <br />
                <strong className="company-data-value">
                  {companyData.successful_withdrawals_count}
                </strong>
              </span>
            </div>
            <div className="col-sm-4">
              <span>
                Successful Withdrawals Volume
                <br />
                <strong className="company-data-value">
                  -{" "}
                  {companyData.successful_withdrawals_amount_sum?.toLocaleString(
                    "pt-br",
                    {
                      style: "currency",
                      currency: "BRL",
                    }
                  )}
                </strong>
              </span>
            </div>
            <div className="col-sm-4">
              <span>
                Successful Withdrawals Users
                <br />
                <strong className="company-data-value">
                  {companyData.successful_withdrawal_users_count}
                </strong>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransactionsPainel;
